// SEASON is no longer hardcoded here.
// It's now stored in Firestore at config/app.currentSeason
// and accessed via DataContext's currentSeason state.
//
// This constant is kept only as a fallback for the initial
// setup when the config doc doesn't exist yet.
export const DEFAULT_SEASON = new Date().getFullYear().toString();

// Logo intro on the logged-out landing page (LogoIntro.jsx). 'hero' flies the
// intro logo into the hero logo; 'skip' doesn't play the intro there at all.
// Every other page always flies into the header logo.
export const LANDING_INTRO = 'hero';
